import { render, staticRenderFns } from "./sendToReward.vue?vue&type=template&id=7c11f128&scoped=true&"
import script from "./sendToReward.vue?vue&type=script&lang=js&"
export * from "./sendToReward.vue?vue&type=script&lang=js&"
import style0 from "./sendToReward.vue?vue&type=style&index=0&id=7c11f128&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c11f128",
  null
  
)

export default component.exports